import { useEffect, useMemo, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useForm, FormProvider, set } from "react-hook-form";
// import { DevTool } from "@hookform/devtools";
import useAxios from "../../hooks/useAxios";
import axiosInstance from "../../apis/commonAPI";
import { BASE_IMG_URL, BASE_URL, SESSION_DATA, user } from "../../constants";
// import { useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { currentIp } from "../../constants";
import apiImageInstance from "../../apis/commonApiImg";
import { MdVerified } from "react-icons/md";
import OtpEnterPopUp from "../../components/registration/OtpEnterPopUp";




const AddUser = () => {
  const navigate = useNavigate();
  const { id } = useParams();
 
  //   const { SESSION_DATA, user } = useSelector((state) => state.user);
  const [addUpdate, setAddUpdate] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const [tpfZone, setTpfZone] = useState(false);
  const [tpfMem, setTpfMem] = useState(false);
  const [tpfBranch, setTpfBranch] = useState(false);
  const [tpfOtherBranch, setTpfOtherBranch] = useState(false);
  const [tpfBranchList, setTpfBranchList] = useState([]);
  const [otpPhone, setOtpPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [otpFlag, setOtpFlag] = useState(false);
  const [phoneVerifiedFlag, setPhoneVerifiedFlag] = useState(false);
  const [alertFlag, setAlertFlag] = useState(false);
      
    


  const [degreeData, errorDegree, loadingDegree, axiosFetchDegree] = useAxios();
  const [submitForm, errorSubmit, loadingSubmit, axiosSubmitUser] = useAxios();
  const [imageLink, errorImageLink, loadingImageLink, axiosFetchImageLink] =
  useAxios();
  const [tpfData, errorTpf, loadingTpf, axiosFetchTpf] = useAxios();
  const [otpData, errorOtp, loadingOtp, axiosFetchOtp] = useAxios();



  const SUBMIT_FORM_DATA_URL = "users/register";
  const DEG_API_URL = "master/getDegreesData";
  const Tpf_API_URL = "master/getAllTpfDataList";




  const form = useForm({
    defaultValues: {},
  });
  const {
    register,
    control,
    handleSubmit,
    formState,
    watch,
    setValue,
    getValues,
    resetField,
    reset,
  } = form;
  const { errors } = formState;
   const GetTpfData = (url) => {
      axiosFetchTpf({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };
   const GetOtpData = (url) => {
      axiosFetchOtp({
        axiosInstance: axiosInstance,
        url: url,
        method: "GET",
      });
    };

  const getQualificationData = (url) => {
    axiosFetchDegree({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

   useEffect(() => {
      GetTpfData(Tpf_API_URL);
    }, [Tpf_API_URL]);

  useEffect(() => {
    getQualificationData(DEG_API_URL);
  }, [DEG_API_URL]);

  const handleTpfZone = (e) => {
    resetField("zone");
    resetField("branch");
    resetField("otherBranch");
   
    if (e.target.value == "y" || e.target.value == "n") {
      if(e.target.value == "y"){
        setTpfMem(true);
      }else{
        setTpfMem(false);
      }
      setTpfZone(true);
      setTpfBranch(false);
      setTpfOtherBranch(false);
    } else {
      setTpfZone(false);
      setTpfBranch(false);
      setTpfOtherBranch(false);
    }
  };
  const handleTpfBranch = (e) => {
    resetField("branch");
    resetField("otherBranch");


    if (e.target.value !== "") {
      tpfData?.[0]?.getAllTpfData?.map((fetchRow, index) => {
        if (e.target.value == fetchRow?._id) {
          setTpfBranchList(fetchRow?.branch);
        }
      });

      setTpfBranch(true);
      setTpfOtherBranch(false);
    } else {
      setTpfBranchList([]);

      setTpfBranch(false);
      setTpfOtherBranch(false);
    }
  };
  const handleTpfOtherBranch = (e) => {
    resetField("otherBranch");

    let branchArr = e.target.value.split("___");
    if (branchArr?.[1] == "Other") {
      setTpfOtherBranch(true);
    } else {
      setTpfOtherBranch(false);
    }
  };
  function isTenDigitPhone(phone) {
    return /^\d{10}$/.test(phone);
  }
  const onFormSubmit = async (data) => {

    const toTitleCase = (str) => {
      return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
        return match.toUpperCase();
      });
    };
   
    
    let formData = {
      email: data?.email?data.email:"",
      username: toTitleCase(data?.username),
      password: String(data?.confPassword),
      usertype: "user",
      phone: String(`91${data?.phone}`),
      age: data.age,
      qualification: data?.qualification,
      profileImagePath: imageFile?imageFile:"",
      status: "A",
      createdBy: "user",
      tpfMember: data?.tpfmember,
      
    };

    const getBranchArr = data?.branch?.split("___");

    formData.zoneId = data?.zone;
    formData.branchId = getBranchArr?.[0];
    formData.branchName = getBranchArr?.[1];

    formData.otherBranchName =
      getBranchArr?.[1] == "Other" ? data?.otherBranch : "";
if(phoneVerifiedFlag){
   await axiosSubmitUser({
      axiosInstance: axiosInstance,
      url: SUBMIT_FORM_DATA_URL,
      method: "POST",
      requestConfig: {
        data: formData,
      },
    });

    setAddUpdate(true);

}else{
  toast.error("Please verify your phone number with OTP", {
      position: toast.POSITION.TOP_RIGHT,
    });
}
   
  };
  useEffect(() => {
    if (errorSubmit) {
      toast.error(`Error!! ${errorSubmit}`, {
        position: toast.POSITION.TOP_RIGHT,
      });
    } else if (addUpdate) {
      navigate(`/user/userlisting`);
    }
  }, [loadingSubmit, errorSubmit]);
  const handleImageUpload = async (e) => {
    if (e.target.files && e.target.files[0]?.size < 1000000) {
      const acceptedFormats = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/gif",
      ];
      const fileExtension = e.target.files[0]?.type;
      if (!acceptedFormats.includes(fileExtension)) {
        resetField("profilePhoto");
        toast.error("Only jpeg, png, jpg, gif image formats are supported", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        setImageFile(URL.createObjectURL(e.target.files[0]));
        let fileData = e.target.files[0];

        const imageData = {
          imageUpload: fileData,
        };
        await axiosFetchImageLink({
          axiosInstance: apiImageInstance,
          url: "/users/uploadImage",
          method: "POST",
          requestConfig: {
            data: imageData,
          },
        });
      }
    } else {
      resetField("profilePhoto");
      toast.error("Error!! upload Valid image ", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };
  useEffect(() => {
    setImageFile(imageLink?.[0]);
  }, [loadingImageLink]);
 
const handlePhone = (value) => {
 

  setPhoneVerifiedFlag(false);
  if(value){
    setOtpPhone(value);
  }else{
  setOtpPhone("");
  }
};
const handleGetOtp = () => {
  resetField("otp");
  setOtp("");
  if(isTenDigitPhone(otpPhone)){
    GetOtpData(`users/getOtp/${otpPhone}`);
    setOtpFlag(true);

  }else{
    toast.error("Please enter a valid 10 digit phone number", {
      position: toast.POSITION.TOP_RIGHT,
    });
  }

}

useEffect(() =>{
if(otpData?.[0]?.success && otpFlag){
  const newOtp = otpData?.[0].data;
  setAlertFlag(true);
  setOtp(newOtp);
        toast.success(
        otpData?.[0]?.message ,
            {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000

            }
        );

}else if(!otpData?.[0]?.success && otpFlag){
      toast.error(
      otpData?.[0]?.message ,
          {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000

          }
      );

}
setOtpFlag(false);

},[otpData]);


  return (
    <>
      <div className="card min-height-100">
        <div className="card-title flex-row">
          <h2 className="text-navyBlue">User Registration </h2>
          <Link to="/user/userlisting">
            <button type = "button" className="btn btn-blue rounded-10">Back</button>
          </Link>
        </div>
        <ToastContainer />
         <OtpEnterPopUp
                       modalFlag={alertFlag}
                      modalFlagUpdate={setAlertFlag}
                      userOtp={otp}
                      modalPhoneVerifiedFlag={setPhoneVerifiedFlag}
                    
                    />

        <FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
              <div className="col-md-4  tank-col-info">
                <label htmlFor="name" className="text-gray text-semi-bold">
                  Full Name<span className="text-red">*</span>
                </label>
                <input
                  id="username"
                  {...register("username", {
                    required: {
                      value: true,
                      message: "Full Name Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Full Name"
                />
                <p className="text-red">{errors.username?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label htmlFor="phone" className="text-gray text-semi-bold">
                  Contact No.<span className="text-red">*</span>
                </label>
                <div className="row">
                <div className="col-md-9  tank-col-info">
                <input
                  id="phone"
                  {...register("phone", {
                    required: {
                      value: true,
                      message: "Mobile field should contains atleast 10 digits",
                    },
                    pattern: {
                      value: /^[0-9]/,
                      message: "Ente Exactly 10 Digits",
                    },
                    minLength: { value: 10, message: "Enter 10 digits" },
                    maxLength: { value: 10, message: "Enter 10 digits" },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Mobile"
                  onChange = {(e) => handlePhone(e.target.value)}
                />
              
                <p className="text-red">{errors.phone?.message}</p>
                </div>
                {/* <div className="col-md-3  tank-col-info">
                <input
                  id="otp"
                  {...register("otp", {
                    required: {
                      value: true,
                      message: "Enter OTP",
                    },
                    pattern: {
                      value: /^[0-9]/,
                      message: "Only Digits are Allowed",
                    },
                    minLength: { value: 6, message: "Enter 6 digits" },
                    maxLength: { value: 6, message: "Enter 6 digits" },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter OTP"
                  
                />
              
                <p className="text-red">{errors.otp?.message}</p>
                </div> */}
                <div className="col-md-3  tank-col-info">
                  {
                    phoneVerifiedFlag ? (
                      <MdVerified className="text-green" size={30} />
                    ) : (
                      <button type= "button" className="btn btn-sm btn-outline-green rounded-10 " onClick={handleGetOtp}>  Get OTP
                      </button>
                    )
                  }
              
                </div>
                </div>
               
              </div>
              <div className="col-md-4  tank-col-info">
                <label htmlFor="age" className="text-gray text-semi-bold">
                  AGE (in years)<span className="text-red">*</span>
                </label>
                <input
                  id="age"
                  {...register("age", {
                    required: {
                      value: true,
                      message: "Age field should contains digits",
                    },
                    pattern: {
                      value: /^[0-9]/,
                      message: "Only Digits are Allowed",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter User Age"
                />
                <p className="text-red">{errors.age?.message}</p>
              </div>

              <div className="col-md-4  tank-col-info">
                <label htmlFor="email" className="text-gray text-semi-bold">
                  Email
                </label>
                <input
                  id="email"
                  {...register("email", {
                    required: {
                      value: false,
                      message: "Email Field is Required",
                    },

                    pattern: {
                      value: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                      message: "Enter Valid Email Id",
                    },
                  })}
                  type="email"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter Email"
                />
                <p className="text-red">{errors.email?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="newPassword"
                  className="text-gray text-semi-bold"
                >
                  {id ? "New Password" : "Password"}{" "}
                  <span className="text-red">*</span>
                </label>
                <input
                  id="newpassword"
                  {...register("newPassword", {
                    required: {
                      value: id !== undefined ? false : true,
                      message: "New Password Field is Required",
                    },
                  })}
                  type="password"
                  className="form-control rounded-10 mb-15"
                  placeholder="Enter New Password"
                />
                <p className="text-red">{errors.newPassword?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="confPassword"
                  className="text-gray text-semi-bold"
                >
                  Confirm Password<span className="text-red">*</span>
                </label>
                <input
                  id="confPassword"
                  {...register("confPassword", {
                    required: {
                      value: id !== undefined ? false : true,
                      message: "Confirm Password Field is Required",
                    },
                    validate: (fieldValue) => {
                      return (
                        fieldValue === watch("newPassword") ||
                        "Your confirm password does no matches with New Password"
                      );
                    },
                  })}
                  type="password"
                  className="form-control rounded-10 mb-15"
                  placeholder="Confirm Password"
                />
                <p className="text-red">{errors.confPassword?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label htmlFor="tpfmember" className="text-gray text-semi-bold">
                  TPF Member<span className="text-red">*</span>
                </label>

                <select
                  id="tpfmember"
                  {...register("tpfmember", {
                    required: {
                      value: true,
                      message: "tpfmember Field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  onChange={handleTpfZone}
                >
                  <option value="">Select TPF Membership</option>
                  <option value="y">Yes</option>
                  <option value="n">No</option>
                </select>

                <p className="text-red">{errors.tpfmember?.message}</p>
              </div>
              {(tpfZone === true ) ? (
                <>
                  <div className="col-md-4  tank-col-info">
                    <label htmlFor="zone" className="text-gray text-semi-bold">
                      {tpfMem==true?"Zone":"Nearest TPF Zone"}<span className="text-red">*</span>
                    </label>

                    <select
                      id="zone"
                      {...register("zone", {
                        required: {
                          value: true,
                          message: "zone Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select zone"
                      onChange={handleTpfBranch}
                    >
                      <option value="">Select zone</option>
                      {tpfData?.[0]?.getAllTpfData?.map((listFetch, index) =>
                        listFetch?.status == "A" ? (
                          <>
                            <option value={`${listFetch?._id}`}>
                              {listFetch?.zone}
                            </option>
                          </>
                        ) : (
                          <></>
                        )
                      )}
                    </select>

                    <p className="text-red">{errors.zone?.message}</p>
                  </div>
                </>
              ) : (
                <>
                
                </>
               
                  
              )}
                 {tpfBranch === true ? (
                <>
                  <div className="col-md-4  tank-col-info">
                    <label
                      htmlFor="branch"
                      className="text-gray text-semi-bold"
                    >
                      {tpfMem==true?"Branch":"Nearest TPF Branch"}<span className="text-red">*</span>
                    </label>

                    <select
                      id="branch"
                      {...register("branch", {
                        required: {
                          value: true,
                          message: "Branch Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Select Branch"
                      onChange={handleTpfOtherBranch}
                    >
                      <option value="">Select Branch</option>
                      {tpfBranchList?.map((listFetch, index) => (
                        <option
                          value={`${listFetch?._id}___${listFetch?.branchName}`}
                        >
                          {listFetch?.branchName}
                        </option>
                      ))}
                    </select>

                    <p className="text-red">{errors.branch?.message}</p>
                  </div>
                </>
              ) : (
                ""
              )}
              {tpfOtherBranch === true ? (
                <>
                  <div className="col-md-4  tank-col-info">
                    <label
                      htmlFor="otherBranch"
                      className="text-gray text-semi-bold"
                    >
                      Other Branch Name<span className="text-red">*</span>
                    </label>
                    <input
                      id="otherBranch"
                      {...register("otherBranch", {
                        required: {
                          value: true,
                          message: "Other Branch Field is Required",
                        },
                      })}
                      type="text"
                      className="form-control rounded-10 mb-15"
                      placeholder="Enter Other Branch "
                    />
                    <p className="text-red">{errors.otherBranch?.message}</p>
                  </div>
                </>
              ) : (
                ""
              )}
              {/* <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="qualification"
                  className="text-gray text-semi-bold"
                >
                  Qualification<span className="text-red">*</span>
                </label>
                <select
                  id="qualification"
                  {...register("qualification", {
                    required: {
                      value: true,
                      message: "Qualification field is Required",
                    },
                  })}
                  type="text"
                  className="form-control rounded-10 mb-15"
                  placeholder="Select Qualification"
                >
                  <option value="">Select Qualification</option>
                  {degreeData?.[0]?.DegreesData?.map((fetchDegree, index) =>
                    fetchDegree?.status == "A" ? (
                      <>
                        <option value={fetchDegree?._id}>
                          {fetchDegree?.degreeName}
                        </option>
                      </>
                    ) : (
                      <></>
                    )
                  )}
                </select>
                <p className="text-red">{errors.qualification?.message}</p>
              </div> */}
              <input
                  id="qualification"
                  {...register("qualification", {
                    required: {
                      value: true,
                      message: "qualification Field is Required",
                    },
                  })}
                  type="hidden"
                  className="form-control rounded-10 mb-15"
                  value="675d55a71a45314439465b37"
                  />

              <div className="col-md-4  tank-col-info">
                <label htmlFor="profilePhoto" className="text-gray text-semi-bold">
                  Photo
                </label>
                <input
                  id="profilePhoto"
                  {...register("profilePhoto", {
                    required: {
                      value: false,
                      message: "Profile Photo Field is Required",
                    },
                  })}
                  type="file"
                  className="form-control rounded-10 mb-15"
                  onChange={(e) => handleImageUpload(e)}
                  />
                <p className="text-red">{errors.photo?.message}</p>
              </div>
              
              {imageFile !=null?<>
                <div className="col-md-4 tank-col-info">
              <label htmlFor="profilePhoto" className="text-gray text-semi-bold">
                  Uploaded Image<span className="text-red"></span>
                </label>
              <img src={ `${BASE_IMG_URL}${imageFile}`} alt="user image"style={{ minWidth: '20%',maxWidth: '20%' }}/>
            </div>
              </>:<></>}
             

              <div className="col-md-12 text-center">
                <input
                  type="submit"
                  className="btn btn-secondary rounded-10"
                  value="Submit"
                />
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </>
  );
};

export default AddUser;
